<div class="container py-4">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h3 class="text-primary">
      <i class="fa-solid fa-user-pen me-2"></i>Editar Cliente
    </h3>
  </div>

  <!-- Errores -->
  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <!-- Formulario -->
  <div class="card shadow-sm border-0">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="mb-3">
          <label for="nombre" class="form-label">Nombre</label>
          <input
            id="nombre"
            type="text"
            class="form-control"
            formControlName="nombre"
            placeholder="Ingrese el nombre del cliente"
            required
          />
        </div>

        <div class="mb-3">
          <label for="telefono" class="form-label">Teléfono</label>
          <input
            id="telefono"
            type="text"
            class="form-control"
            formControlName="telefono"
            placeholder="Ej: 1123456789"
            required
          />
        </div>

        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input
            id="email"
            type="email"
            class="form-control"
            formControlName="email"
            placeholder="cliente@ejemplo.com"
            required
          />
        </div>

        <div class="d-flex justify-content-end gap-2 mt-4">
          <button type="button" class="btn btn-outline-secondary" (click)="volverAtras()">
            <i class="fa-solid fa-xmark me-2"></i>Cancelar
          </button>
          <button type="submit" class="btn btn-success" [disabled]="loading || form.invalid">
            <i class="fa-solid fa-floppy-disk me-2"></i>
            {{ loading ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

